<!--Tarjeta de afiliaciación de usuario
    Por cada afiliación que tenga un usuario se mostrará este componente la misma cantidad 
    de veces que las afiliaciones completadas o on proceso que tenga el usuario-->
<template>
  <v-card hover class="fill-height">
    <v-container fluid class="fill-height">
      <v-row justify="center" align="center">
        <v-col cols="12">
          <v-row justify="center" align="center">
            <v-col cols="12" sm="3" class="py-0">
              <v-row justify="center">
                <v-avatar size="100">
                  <img :src="affiliation.organizer.profilePicture" />
                </v-avatar>
              </v-row>
            </v-col>
            <v-col cols="12" sm="9">
              <v-row>
                <v-col cols="11" md="6" class="text-center text-md-left">
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <h2 class="title font-weight-bold" style="display:inline;">Nombre:</h2>
                      {{affiliation.name}}
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <h2 class="title font-weight-bold" style="display:inline;">Nivel:</h2>
                      {{ affiliation.affiliation.tier.name }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <!-- <v-row class="my-2" justify="center">
                    <v-btn small class="accent">Desuscribir</v-btn>
                  </v-row>-->
                  <v-row class="my-0 my-md-2 fill-height" justify="center" align="center">
                    <v-btn
                      small
                      class="accent"
                      :to="`/afiliaciones/${affiliation.order.id}`"
                    >Ver detalles</v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row justify="center" align="center" class="text-center">
            <v-col cols="6" class="pb-0">
              <h3 class="subtitle-2 font-weight-bold" style="display:inline;">Expiración:</h3>
              {{ formatDate(affiliation.expirationDate) || 'N/D' }}
            </v-col>
            <v-col cols="6" class="pb-0">
              <h3 class="subtitle-2 font-weight-bold" style="display:inline;">Estatus:</h3>
              {{ (affiliation.estatus==='ACTIVE')?'Activa':(affiliation.estatus==='INACTIVE')?'Inactiva':'En proceso' }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  props: {
    affiliation: { type: Object, required: true }
  },
  data() {
    return {
      overlay: false
    };
  },
  methods: {
    details() {
      this.$router.push({
        name: "plan-detail",
        params: { id: this.affiliation.id }
      });
    },
    formatDate(date) {
      if (date) {
        let dateArr = date.split("-");
        return `${dateArr[2].substring(0, 2)}-${dateArr[1]}-${dateArr[0]}`;
      }
    }
  },
  computed: {
    beforeDate() {
      let today = new Date();
      let date = this.affiliation.startDate.split("-");
      let eventDate = new Date(date[0], Number(date[1]) - 1, date[2]);
      if (eventDate >= today) return true;
      else return false;
    }
  }
};
</script>
<style scoped>
</style>
